<template>
  <v-container
    fluid
  >

      <v-tabs fixed-tabs  hide-slider v-model="activeTab" >
        <v-tab key="tab-1" :to="{ name: 'ProjectShow', params: { 'id': id }}">
          {{$t('projects.submenu.projectDetails')}}
        </v-tab>
        <v-tab key="tab-2" :to="{ name: 'ProjectBarrierChecklist', params: { 'id': id }}">
          {{$t('projects.submenu.barrierChecklist')}}
        </v-tab>
        <v-tab  key="tab-3" :to="{ name: 'ProjectRiskAnalysisSummary', params: { 'id': id }}">
          {{$t('projects.submenu.riskAnalysis')}}
        </v-tab>


      </v-tabs>
      <v-row>
        <v-col>
          <v-card>
            <v-card-text>
              <v-container class="pa-0"  fluid>
                <v-row justify="center">

                  <v-col>
                    <a @click="backToProject">     {{$t("projects.submenu.backToProject")}}</a>
                    <v-card-text>
                      <div id ="projectHeader">
                          <h2 class="font-weight-light mb-4">
                            {{projectName}}
                          </h2>
                        <!--
                          <v-row>
                            <v-col cols="3">
                              {{$t('project.location')}}:
                            </v-col>
                            <v-col cols="8">
                              {{location}}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">
                              {{$t('project.projectNumber')}}:
                            </v-col>
                            <v-col cols="8">
                              {{projectNumber}}
                            </v-col>
                          </v-row>

                          -->
                      </div>
                    </v-card-text>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    {{$t("projects.show.riskBeforeMeasures")}}
                    <v-simple-table >
                      <tbody>
                      <tr><th></th><th  v-for="cons in consequenceStrengths">{{cons.name}}</th> </tr>

                      <tr v-for="level in probabilityLevels.slice().reverse()">
                        <th   scope="row">{{level.name}}</th>
                        <td  v-for="cons in consequenceStrengths" :class="getRiskColor(level.id,cons.id)">
                          {{
                          incidentsPerCellBefore[cons.id-1][level.id-1]>0?incidentsPerCellBefore[cons.id-1][level.id-1]:''}}

                        </td>
                      </tr>

                      </tbody>
                    </v-simple-table>

                  </v-col>


                  <v-col cols="6">
                    {{$t("projects.show.riskAfterMeasures")}}
                    <v-simple-table >
                      <tbody>
                      <tr><th></th><th v-for="cons in consequenceStrengths">{{cons.name}}</th> </tr>

                      <tr v-for="level in probabilityLevels.slice().reverse()">
                        <th  scope="row">{{level.name}}</th>
                        <td v-for="cons in consequenceStrengths"  :class="getRiskColor(level.id,cons.id)">
                          {{ incidentsPerCellAfter[cons.id-1][level.id-1]>0?incidentsPerCellAfter[cons.id-1][level.id-1]:''}}


                        </td>
                      </tr>

                      </tbody>
                    </v-simple-table>

                  </v-col>
                </v-row>


              <v-row>
                <v-col>
                  <h2 class="font-weight-light mb-4">{{$t("projects.barrierChecklist.selectWorkTypes")}}</h2>
                </v-col>

              </v-row>
              <v-row>


                <v-col cols="12" md="6">
                  <v-select
                    v-model="selectedWorkTypes"
                    :items="workTypes"
                    chips
                    multiple
                    clearable
                    :item-text="'name'"
                    :item-value="'id'"
                    :label="$t('potentialIncident.workType')"
                    @change="getWorkOperations"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :disabled="selectedWorkTypes.length==[]"
                    v-model="selectedWorkOperations"
                    :items="workOperations"
                    chips
                    clearable
                    multiple
                    :item-text="'name'"
                    :item-value="'id'"
                    :label="$t('potentialIncident.workOperation')"

                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="selectedLocations"
                    :items="locations"
                    chips
                    clearable
                    multiple
                    :item-text="'name'"
                    :item-value="'id'"
                    :label="$t('potentialIncident.location')"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    @click="showBarrierCheckList">
                    {{$t("projects.barrierChecklist.showBarrierChecklist")}}
                  </v-btn> &nbsp;
                  <v-btn  v-if="barrierChecklist.length>0"
                         @click="exportCheckListToPdf">
                    {{$t("projects.barrierChecklist.exportChecklistToPdf")}}
                  </v-btn>&nbsp;
                  <v-btn  :loading="loading" v-if="barrierChecklist.length>0"
                         @click="exportCheckListToExcel">
                    {{$t("projects.barrierChecklist.exportChecklistToExcel")}}
                  </v-btn>
                  <!--&nbsp;
                  <v-btn v-if="barrierChecklist.length>0"
                         @click="print">
                    Print
                  </v-btn>
                  -->
                </v-col>
              </v-row>

                <div id="barrierChecklist">
              <v-row v-if="barrierChecklist.length>0">

                  <v-col cols="12" md="12">
                    <material-card
                      :title="$t('projects.barrierChecklist.checklistTitle') "
                    >
<!-- group-by="workTypeName" -->

                      <v-data-table
                      :headers="barrierChecklistHeaders"
                      :items="barrierChecklistDataTable"
                      hide-default-footer
                      :items-per-page=1000>



                        <template v-slot:item.risk="{ item  }">

                           <div :class="getRiskColor(item.probability.id, item.consequence.id)" >{{item.risk}}</div>
                         </template>


                      <template v-slot:item.checkMark="{ item  }">
                        <input disabled type="checkbox">
                      </template>

                      <template v-slot:group.header="{ group  }">
                        <td :colspan="barrierChecklistHeaders.length" class="px-2">

                          {{$t('potentialIncident.workType')}}: {{ group }}
                      </td>
                      </template>


                    </v-data-table>
                    </material-card>
                  </v-col>
              </v-row>

                <v-row v-if="barrierChecklist.length>0">

                  <v-col cols="12" md="12">
                    <material-card
                      :title="$t('projects.barrierChecklist.measuresTitle')"
                    >
                   <!-- group-by="workTypeName" -->

                      <v-data-table
                      :headers="measuresHeaders"
                      :items="measuresDataTable"
                      hide-default-footer
                      :items-per-page=1000>


                        <template v-slot:item.risk="{ item  }">

                           <div :class="getRiskColor(item.probability.id, item.consequence.id)" >{{item.risk}}</div>
                        </template>

                      </v-data-table>


                    </material-card>
                  </v-col>
                </v-row>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
      </v-col></v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import languageUtil from '../utils/language'
    import riskUtil from '../utils/riskutil'
    import jsPDF from 'jspdf'
    import jsPDFautotable from 'jspdf-autotable';


    export default {
        data() {
            return {
                id:"",
                projectName:"",
                location:"",
                projectNumber:"",
                potentialIncidents: [],
                potentialIncidentsFiltered: [],
                filteredView:false,
                probabilityLevels: [],
                consequenceStrengths: [],
                workTypes:[],
                selectedWorkTypes:[],
                selectedWorkOperations:[],
                selectedLocations:[],
                locations:[],
                workOperations:[],
                barrierChecklist:[],
                search: "",
                activeTab:1,
                loading:false,
                barrierChecklistDataTable:[],
                barrierChecklistHeaders: [
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.logicalId"),
                        value: 'logicalId'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.workType"),
                        value: 'workTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.workOperation"),
                        value: 'workOperationName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.incidentType"),
                        value: 'incidentTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.location"),
                        value: 'location'
                    },
                    {
                      sortable: true,
                      text: this.$i18n.t("potentialIncident.risk"),
                      value: 'risk'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("barrier.description"),
                        value: 'description'
                    },


                    {
                        sortable: true,
                        text: this.$i18n.t("barrier.owner"),
                        value: 'owner'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("barrier.checkMark"),
                        value: 'checkMark'
                    }
                ],
                measuresHeaders: [
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.logicalId"),
                        value: 'logicalId'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.workType"),
                        value: 'workTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.workOperation"),
                        value: 'workOperationName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.incidentType"),
                        value: 'incidentTypeName'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("potentialIncident.location"),
                        value: 'location'
                    },
                  {
                    sortable: true,
                    text: this.$i18n.t("potentialIncident.risk"),
                    value: 'risk'
                  },
                    {
                        sortable: true,
                        text: this.$i18n.t("measure.measure"),
                        value: 'measure'
                    },
                    {
                        sortable: true,
                        text: this.$i18n.t("measure.measureResponsible"),
                        value: 'measureResponsible'
                    }
                ],
                measuresDataTable:[]

            }
        },
        methods: {

            clearFilterOnIncidents() {
                this.potentialIncidentsFiltered = this.potentialIncidents
                this.filteredView=false
            },
            getProject(projectid) {
                api.getProject(projectid).then(response => {
                    this.id = response.id
                    this.projectName= response.name
                    this.location = response.location
                    this.projectNumber = response.projectNumber

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getPotentialIncidents(projectid) {
                api.getPotentialIncidents(projectid).then(response => {
                    this.potentialIncidents = response
                    this.potentialIncidentsFiltered = this.potentialIncidents
                    this.workTypes = this.potentialIncidents.slice().map(ele =>ele.workType)
                    this.locations = this.potentialIncidents.slice().filter(ele=> ele.location.id>0).map(ele=>ele.location)

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            showPotentialIncident(rowdata) {
                this.$router.push({ path: '/potentialIncidentShow/' + rowdata.id })
            },
            getRiskColor(probability, consequence) {
                return riskUtil.getRiskColor(probability, consequence)
            },
            getProbabilityLevels () {
                api.getProbabilityLevels().then(response => {
                    this.probabilityLevels= response.map(function(strength) { return {'id':strength.strength, 'name':strength.name + ' (' + strength.strength + ')'}})
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getConsequenceStrengths() {
                api.getConsequenceStrengths().then(response => {
                    this.consequenceStrengths= response.map(function(strength) { return {'id':strength.strength, 'name':strength.name + ' (' + strength.strength + ')'}})
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getWorkOperations() {

                var operationsFiltered = this.potentialIncidents.filter(ele=>{ return this.selectedWorkTypes.includes(ele.workType.id)})

                this.workOperations =operationsFiltered.map(ele =>ele.workOperation)
              this.selectedWorkOperations = this.selectedWorkOperations.filter(ele=>{return this.workOperations.map(ele2=>ele2.id).includes(ele)})

            },

            showBarrierCheckList() {
                if (this.selectedWorkTypes.length == 0) {
                    this.barrierChecklist = this.potentialIncidents.slice();
                } else {
                    this.barrierChecklist = this.potentialIncidents.filter(ele => {
                        return this.selectedWorkTypes.includes(ele.workType.id)
                    })
                    if (this.selectedWorkOperations.length > 0) {
                        let sortedList = []
                        this.selectedWorkOperations.forEach(l=> {
                            sortedList = sortedList.concat(this.barrierChecklist.filter(ele => {
                                return ele.workOperation.id == l}))
                        })

                        this.barrierChecklist = sortedList
                    }
                }
                if (this.selectedLocations.length > 0) {
                    this.barrierChecklist = this.barrierChecklist.filter(ele => {
                        return this.selectedLocations.includes(ele.location.id)
                    })
                }
                this.barrierChecklistDataTable = []
                this.measuresDataTable = []
                this.potentialIncidentsFiltered = this.barrierChecklist
                this.barrierChecklist.forEach(item => {
                     item.barriers.forEach(barrier => {
                         this.barrierChecklistDataTable.push( {
                              "logicalId":item.logicalId,
                              "workTypeName":item.workType.name,
                              "workOperationName":item.workOperation.name,
                              "incidentTypeName":item.incidentType.name,
                           "probability": item.probability,
                           "consequence": item.consequence,
                              "risk": item.risk,
                              "location":item.location.name,
                              "description":barrier.description,
                              "type": barrier.type,
                              "owner": barrier.owner.name
                        })
                    })
                })
                this.barrierChecklist.forEach(item => {
                        item.measures.forEach(measure => {
                        this.measuresDataTable.push({
                            "logicalId":item.logicalId,
                            "workTypeName": item.workType.name,
                            "workOperationName": item.workOperation.name,
                            "incidentTypeName": item.incidentType.name,
                            "location": item.location.name,
                          "probability": item.probability,
                          "consequence": item.consequence,
                          "risk": item.risk,
                            "measure": measure.measure,
                            "measureResponsible": measure.measureResponsible.name

                        })
                    })
                })

            },
            backToProject() {
                this.$router.push({path: '/projectShow/' + this.id});
            },
            exportCheckListToExcel() {
              this.loading = true
                api.downloadBarrierChecklist(this.id, this.selectedWorkTypes, this.selectedWorkOperations,this.selectedLocations, this.setLoadingToFalse)
            },
          setLoadingToFalse() {
              this.loading = false;
          },
            exportCheckListToPdf() {
                let lineHeight = 1.2,
                    font = 'Verdana',
                    fontSize = 12,
                    oneLineHeight = 20,
                    pdf = new jsPDF({
                        orientation:'landscape',
                        unit: 'pt',
                        lineHeight: lineHeight
                    }).setProperties({title:  this.$i18n.t("projects.barrierChecklist.checklistTitle")});
                pdf.setFont(font);
                pdf.setFontSize(fontSize);




                //prepare table headers
                let barrierColumns = [
                    { title: this.$i18n.t("potentialIncident.logicalId"), dataKey: "A" },
                    { title: this.$i18n.t("potentialIncident.workType"), dataKey: "B" },
                    { title: this.$i18n.t("potentialIncident.workOperation"), dataKey: "C" },
                    { title: this.$i18n.t("potentialIncident.incidentType"), dataKey: "D" },
                  { title: this.$i18n.t("potentialIncident.risk"), dataKey: "E" },

                  { title: this.$i18n.t("barrier.description"), dataKey: "F" },
                    { title: this.$i18n.t("barrier.owner"), dataKey: "G" },
                    { title: this.$i18n.t("barrier.checkMark"), dataKey: "H" }
                ];
                let measuresColumns = [
                    { title: this.$i18n.t("potentialIncident.logicalId"), dataKey: "A" },
                    { title: this.$i18n.t("potentialIncident.workType"), dataKey: "B" },
                    { title: this.$i18n.t("potentialIncident.workOperation"), dataKey: "C" },
                    { title: this.$i18n.t("potentialIncident.incidentType"), dataKey: "D" },
                  { title: this.$i18n.t("potentialIncident.risk"), dataKey: "E" },
                    { title: this.$i18n.t("measure.measure"), dataKey: "F" },
                    { title: this.$i18n.t("measure.measureResponsible"), dataKey: "G" }

                ];
                let barrierRows = [];
                let measuresRows = [];
                var measuresRow;
                var barrierRow;
                this.barrierChecklist.forEach(item => {

                    var firstRow = true;
                    item.measures.forEach(measure => {
                        if (firstRow) {
                            measuresRow = {
                              A: item.logicalId,
                              B: item.workType.name,
                              C: item.workOperation.name,
                              D: item.incidentType.name,
                              E: item.risk,
                              F: measure.measure,
                              G: measure.measureResponsible.name
                          };
                          firstRow = false;
                        } else {
                            measuresRow = {
                                A: "",
                                B: "",
                                C: "",
                                D:"",
                              E: "",
                                F: measure.measure,
                                G: measure.measureResponsible.name
                            };
                        }
                        measuresRows.push(measuresRow);


                    })
                    var firstRow = true;
                    item.barriers.forEach(barrier => {
                      pdf.setFontType("bold");
                      pdf.setFontType("normal");
                      if (firstRow) {
                           barrierRow = {
                               A: item.logicalId,
                               B: item.workType.name,
                               C: item.workOperation.name,
                               D: item.incidentType.name,
                             E: item.risk,
                              F: barrier.description,
                              G: barrier.owner.name,
                              H: "☐"
                          };
                          firstRow = false;

                      } else {
                           barrierRow = {
                              A: "",
                              B: "",
                              C: "",
                              D : "",
                             E: "",
                              F: barrier.description,
                              G: barrier.owner.name,
                              H: ""
                          };
                      }


                      barrierRows.push(barrierRow);

                  });
                });
                let currentHeight = 70, lines=[]

               pdf.setFontSize(15)
                pdf.text(30,40, this.$i18n.t("projects.barrierChecklist.checklistTitle"))
                pdf.setFontSize(13)
                pdf.text(30,currentHeight,this.$i18n.t("project.name") + ":")
                pdf.text(140,currentHeight,this.projectName)

                currentHeight +=oneLineHeight
                pdf.text(30,currentHeight,this.$i18n.t("project.projectNumber") + ":")
                pdf.text(140,currentHeight,this.projectNumber)
                currentHeight +=oneLineHeight

                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.workTypes") + ":")
                 lines = this.getNamesAsString(this.selectedWorkTypes, this.workTypes,pdf)
                pdf.text(140,currentHeight,lines)
                currentHeight +=oneLineHeight*(lines.length)

                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.workOperations") + ":")
                lines = this.getNamesAsString(this.selectedWorkOperations, this.workOperations,pdf)
                pdf.text(140,currentHeight,lines)
                currentHeight +=oneLineHeight*(lines.length)

                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.locations") + ":")
                lines = this.getNamesAsString(this.selectedLocations, this.locations,pdf)
                pdf.text(140,currentHeight,lines)
                currentHeight +=oneLineHeight*(lines.length)



                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.date") + ":")
                var today = new Date()
                  pdf.text(140,currentHeight,today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, '0') + "-" + String(today.getDate()).padStart(2, '0'))

                pdf.setFontSize(fontSize);




              currentHeight +=oneLineHeight+5


              var logoImage;
              if (this.currentCustomerLogicalId==="omexom_norge" || this.currentCustomerLogicalId==="omexom_norge_en" || this.currentCustomerLogicalId==="omexom_sverige") {
                logoImage = new Image();
                var src = "/customerlogos/vinci.jpeg";
                logoImage.src = src;
              }



                pdf.autoTable({
                  styles: {cellWidth:'auto'},
                  margin: {top: 110},
                  didDrawPage: function(data) {
                    if (logoImage)
                      pdf.addImage(logoImage, "jpg", 650, 25, 150, 56);

                  },

                  columnStyles: {A: {minCellWidth:30},
                                  B: {minCellWidth:95},
                                  C: {minCellWidth:95},
                                 D: {minCellWidth:100},
                                E: {minCellWidth:40},
                                F: {minCellWidth:250},
                                G: {minCellWidth:100},
                                H:{minCellWidth:40} },

                  columns: barrierColumns, body: barrierRows,
                              theme: 'grid',
                              startY:currentHeight,

                      didParseCell: data => {
                        if (data.section === 'body' && data.column.index === 7) {
                          data.cell.text = '[ ]';
                        }
                      }


                      /**,
                        Try to set color of Risk cell. Hard to achieve
                        createdCell: function(data) {
                          if (data.section === 'body' && data.column.index ===4) { // count startrs from 0
                            // cell.raw contains the cell data
                            data.cell.styles.fillColor ="green base  text-center ";    // random color
                           }

                      }

                       **/

                    });
                pdf.addPage()
                currentHeight = 130
                lines=[]


                pdf.setFontSize(15)
                pdf.text(30,40, this.$i18n.t("projects.barrierChecklist.measuresTitle"))
                pdf.setFontSize(13)
                pdf.text(30,currentHeight,this.$i18n.t("project.name") + ":")
                pdf.text(140,currentHeight,this.projectName)

                currentHeight +=oneLineHeight
                pdf.text(30,currentHeight,this.$i18n.t("project.projectNumber") + ":")
                pdf.text(140,currentHeight,this.projectNumber)
                currentHeight +=oneLineHeight

                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.workTypes") + ":")
                lines = this.getNamesAsString(this.selectedWorkTypes, this.workTypes,pdf)
                pdf.text(140,currentHeight,lines)
                currentHeight +=oneLineHeight*(lines.length)

                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.workOperations") + ":")
                lines = this.getNamesAsString(this.selectedWorkOperations, this.workOperations,pdf)
                pdf.text(140,currentHeight,lines)
                currentHeight +=oneLineHeight*(lines.length)

                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.locations") + ":")
                lines = this.getNamesAsString(this.selectedLocations, this.locations,pdf)
                pdf.text(140,currentHeight,lines)
                currentHeight +=oneLineHeight*(lines.length)


                pdf.text(30,currentHeight,this.$i18n.t("projects.barrierChecklist.date") + ":")
                var today = new Date()
                pdf.text(140,currentHeight,today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, '0') + "-" + String(today.getDate()).padStart(2, '0'))

                pdf.setFontSize(fontSize);



              currentHeight +=oneLineHeight+5

                 pdf.setFontSize(fontSize);
                pdf.autoTable({
                  styles: {cellWidth:'auto'},
                  margin: {top: 130},
                  didDrawPage: function(data) {
                    if (logoImage)
                      pdf.addImage(logoImage, "jpg", 660, 25, 140, 74);


                  },
                  columnStyles: {A: {minCellWidth:30},
                    B: {minCellWidth:100},
                    C: {minCellWidth:100},
                    D: {minCellWidth:100},
                    E: {minCellWidth:40},
                    F: {minCellWidth:290},
                    G: {minCellWidth:80}},


                  columns: measuresColumns, body: measuresRows,
                    theme: 'grid',
                    startY:currentHeight

                });
                pdf.save("barrierChecklist.pdf");
            },
            getNamesAsString(idList, fullList, pdf) {
                var combined = "";

                if (idList.length==0) {
                    combined =  this.$i18n.t("projects.barrierChecklist.all");
                } else {
                    var delimiter = ", ";
                    idList.forEach(id=> {
                        if (combined.length>0) {
                            combined = combined + delimiter;
                        }
                        combined = combined + fullList.filter(ele=>{return ele.id==id}).pop().name


                    })

                }

                return pdf.splitTextToSize(combined, 600);


            }


        },
        computed: {
            incidentsPerCellBefore() {
                var incidentsPerCellBefore = [];
                this.consequenceStrengths.forEach(stren=>{
                    var incidentsPerRow=  []
                    this.probabilityLevels.forEach(level=>{
                        incidentsPerRow.push( this.potentialIncidentsFiltered.slice().filter(function(ele){return ele.consequence!=null && ele.probability!=null && ele.consequence.id==stren.id && ele.probability.id==level.id}).length)
                    })
                    incidentsPerCellBefore.push(incidentsPerRow)
                })
                return incidentsPerCellBefore;

            },
            incidentsPerCellAfter() {
                var incidentsPerCellAfter = [];
                this.consequenceStrengths.forEach(stren=>{
                    var incidentsPerRow=  []
                    this.probabilityLevels.forEach(level=>{
                        incidentsPerRow.push( this.potentialIncidentsFiltered.slice().filter(function(ele){return ele.consequenceAfterMeasures!=null && ele.probabilityAfterMeasures!=null && ele.consequenceAfterMeasures.id==stren.id && ele.probabilityAfterMeasures.id==level.id}).length)
                    })
                    incidentsPerCellAfter.push(incidentsPerRow)
                })
                return incidentsPerCellAfter;

            }

        },
        mounted() {
            this.getProject(this.$route.params.id)
            this.getPotentialIncidents(this.$route.params.id)
            this.getConsequenceStrengths()
            this.getProbabilityLevels()
        }
    }
</script>
